export default __webpack_public_path__ + "static/media/icon_course.e023b35b.svg";